<template>
  <el-dialog title="新增风险预警"
             :visible.sync="visible"
             width="1140px"
             append-to-body
             @closed="onClosed"
             :close-on-press-escape="false">
    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-position="top"
             label-width="90px">
      <el-form-item label="预警信息:"
                    prop="warning">
        <el-input type="textarea"
                  :rows="3"
                  v-model="ruleForm.warning"></el-input>
      </el-form-item>
    </el-form>
    <el-tabs :value="activeName"
             v-loading="loading"
             v-if="visible"
             @tab-click="handleClick">
      <el-tab-pane label="请选择企业"
                   name="1">
        <category-table ref="category"
                        :config="config"
                        @update="onUpdateConfig" />
      </el-tab-pane>
      <el-tab-pane label="请选择产品"
                   :disabled="!config.vendorId"
                   name="2">
        <spec-table ref="spec"
                    :config="config"
                    @update="onUpdateConfig" />
      </el-tab-pane>
      <el-tab-pane label="请选择批次"
                   :disabled="!config.productId"
                   name="3">
        <attr-table ref="attr"
                    :config="config" />
      </el-tab-pane>
    </el-tabs>
    <div slot="footer">
      <div class="select-info">
        <span style="font-size: 14px;">已选择：</span>
        <el-link type="primary"
                 :underline="false"
                 v-if="config.vendorId">{{ config.vendorName }}</el-link>
        <el-link type="primary"
                 :underline="false"
                 v-if="config.productId">—{{ config.productName }}</el-link>
      </div>
      <el-button @click="visible = false"
                 :loading="loading">取 消</el-button>
      <el-button type="primary"
                 @click="handleSubmit"
                 :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import CategoryTable from './category/category-table.vue'
import SpecTable from './category/spec-table.vue'
import AttrTable from './category/attr-table.vue'
export default {
  name: 'risk-warning-modal',
  components: { CategoryTable, SpecTable, AttrTable },
  props: {
    callback: { type: Function, default () {} }
  },
  data () {
    return {
      visible: false,
      loading: false,
      activeName: '1',
      config: { vendorId: null, vendorName: '', productId: null, productName: '' },
      ruleForm: { warning: '' },
      rules: {
        warning: [
          { required: true, message: '请输入预警信息', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    onClosed () {
      this.activeName = '1'
      this.ruleForm.warning = ''
      this.config = { ...this.config, vendorId: null, vendorName: '', productId: null, productName: '' }
    },
    handleSubmit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const batchRef = this.$refs.attr
          const batchList = batchRef.getSelections()
          if (batchList.length === 0) {
            this.$message.error('请选择批次')
            return
          }
          this.loading = true
          const { vendorId, productId } = this.config
          const { warning } = this.ruleForm
          const batchs = batchList.map(i => ({ batchId: i.batchId }))
          this.$$SuperviseApi.addriskwarning({ vendorId, productId, status: 1, batchs, warning })
            .then(res => {
              const { result, message } = res.data
              this.loading = false
              if ([0].includes(result)) {
                this.$message.success('新增企业产品批次风险预警成功')
                setTimeout(() => {
                  this.visible = false
                  this.callback()
                }, 1000)
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    handleClick (tab) {
      if (tab.name === this.activeName) {
        if (tab.name === '1') {
          this.$refs.category.fetchList()
        }
        if (tab.name === '2') {
          this.$refs.spec.fetchList()
        }
        if (tab.name === '3') {
          this.$refs.attr.fetchList()
        }
      }
      this.activeName = tab.name
    },
    onUpdateConfig (config, name) {
      this.config = { ...this.config, ...config }
      if (name === 1) {
        this.activeName = '2'
        setTimeout(() => {
          this.$refs.spec.fetchList()
        }, 500)
      }
      if (name === 2) {
        this.activeName = '3'
        setTimeout(() => {
          this.$refs.attr.fetchList()
        }, 500)
      }
    },
    init () {
      this.visible = true
      setTimeout(() => {
        this.$refs.category.fetchList()
      }, 100)
    }
  }
}
</script>
<style lang="stylus" scoped>
/deep/ .el-table .current-select-row {
  background: #f0f9eb !important;
}

/deep/ .el-breadcrumb__inner {
  color: #409eff !important;
}

.select-info {
  text-align: left;
}
</style>
